module.exports = __webpack_public_path__ + "media/newstyle/images/70-mil-authors-aus-682e10d8b0a633595dac75388a2f023a.svg";